import { useTranslation } from 'react-i18next';

import { NgButton } from '@/ui';
import { usePsapConfiguration } from '@/app/shell/psapConfiguration';
import { getShareIncidentRelatedPsaps } from './model/psapConfiguration';

export type IncidentDetailActionBarItemsProps = {
  incidentId: string;
  incidentIsReadOnly: boolean;
  onAddPsapToIncident: () => void | Promise<void>;
  onOpenShareByLinkDialog: () => void | Promise<void>;
  onCloseIncident: () => void | Promise<void>;
};

export function IncidentDetailActionBarItems({
  incidentIsReadOnly,
  onAddPsapToIncident,
  onOpenShareByLinkDialog,
  onCloseIncident,
}: IncidentDetailActionBarItemsProps) {
  const { t } = useTranslation();
  const psapConfiguration = usePsapConfiguration();
  const relatedPsaps = getShareIncidentRelatedPsaps(psapConfiguration);

  return (
    <>
      {!incidentIsReadOnly && relatedPsaps.length > 0 && (
        <NgButton
          text={t('Incident_Button_AddPsapToIncident')}
          outline
          icon="fal fa-phone-plus"
          onClick={onAddPsapToIncident}
        />
      )}

      <NgButton
        text={t('Incident_Button_ShareViaLink')}
        outline
        icon="fal fa-share-from-square"
        onClick={onOpenShareByLinkDialog}
      />

      {!incidentIsReadOnly && (
        <NgButton
          text={t('Incident_Button_CloseIncident')}
          outline
          type="danger"
          icon="fal fa-xmark"
          confirmationMessage={t('Incident_Button_CloseIncident_Confirmation')}
          onClick={onCloseIncident}
          enableMultipleClickPrevention
        />
      )}
    </>
  );
}
